<div class="content-wrapper">
	<table class="mainTable" width="98%" cellspacing="2" cellpadding="0">
		<tbody>

			<!-- empty one-->
			<tr>
				<td>&nbsp;</td>
				<td></td>
			</tr>
			<tr>
				<td colspan="2"></td>
			</tr>

			<!-- 1st block-->
			<tr>
				<td>&nbsp;</td>
				<td width="99%" valign="top">
					<div class="whatsnewBorder" style="padding: 5px; width: 99%; ">
						<form name="userSearchForm" method="post" action="/manageuser" id="userSearchForm">
							<div class="summaryTitle">
								<table>
									<tbody>
										<tr>
											<td><span class="summaryTitle">{{'Search for users to assign/update users access to SBD-O roles'|translate}}</span></td>
										</tr>
										<tr>
											<td>&nbsp;</td>
										</tr>
										<tr>
											<td>{{'Username'|translate}}:<input [(ngModel)]="username" type="text" name="username"
													size="10" value="" id="username">&nbsp;
												{{'Last Name'|translate}}:<input [(ngModel)]="lastName" type="text" name="lastName"
													size="10" value="" id="lastName">&nbsp;
												<select name="userType" [(ngModel)]="staff">
													<option value="0" selected="selected">{{'All Users (0, all)'|translate}}</option>
													<option value="1">{{'Ford Internal Personnel (1, fs)'|translate}}</option>&nbsp;
													<option value="2">{{'Independent Operator (2, ir)'|translate}}</option>&nbsp;
													<option value="3">{{'Authorized Repairer (3, ar)'|translate}}</option>
												</select>&nbsp;
												<input type="button" value="{{'Submit'|translate}}"
													(click)="getUserDetailsInput(content)">&nbsp;
												<input type="button" type="reset" value="{{'Clear'|translate}}" (click)="closetabs()">
												<div id="userSearchErrors">{{errormsg}}</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</form>
					</div>
				</td>
			</tr>

			<!-- 2nd block -->
			<tr *ngIf="showhideblock1">
				<td>&nbsp;</td>
				<td>
					<div class="whatsnewBorder" style="padding: 5px; width: 99%;">
						<table>
							<tbody>
								<tr>
									<td class="summaryTitle">{{'Username'|translate}}:</td>
									<td class="summaryTitle spanstyle">{{uname}}</td>
								</tr>
								<tr>
									<td class="summaryTitle">{{'User's Full Name'|translate}}:</td>
									<td class="summaryTitle spanstyle">{{userfullname}}&nbsp;{{surname}}</td>
								</tr>
								<tr>
									<td class="summaryTitle">{{'User's Email Address'|translate}}:</td>
									<td class="summaryTitle spanstyle">{{email}}</td>
								</tr>
								<tr>
									<td class="summaryTitle">{{'User's Language Code'|translate}}:</td>
									<td class="summaryTitle spanstyle">{{language}}</td>
								</tr>
								<tr>
									<td class="summaryTitle">{{'User's Market Country Code'|translate}}:</td>
									<td class="summaryTitle spanstyle">{{countrycode}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</td>
			</tr>

			<!-- 3rd block -->
			<tr *ngIf="showhideblock1">
				<td>&nbsp;</td>
				<td>
					<form id="roleForm" scope="request" onsubmit="return false;">
						<!-- <input type="hidden" name="userId" value="61835251"> -->
						<table width="100%" cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td>
										<div id="userAccess" class="whatsnewBorder" style="padding: 5px; width: 99%;">
											<table style="width:100%; padding:20px;">
												<tbody>
													<tr>
														<td align="center">{{'Available Roles'|translate}}</td>
														<td>&nbsp;</td>
														<td align="center">{{'Selected Roles'|translate}}</td>
													</tr>

													<tr>
														<td style="width:45%;">
															<select style="width:100%;" size="10" multiple="true"
																name="qualifier" [(ngModel)]="useravail">
																<option *ngFor="let d of getselectuserdetailavail">{{d}}
																</option>
															</select>
														</td>

														<td style="text-align:center; width:10%;">
															<input type="button" value=">>" (click)="addall()"><br>
															<input type="button" value=" ->" (click)="add()"><br>
															<input type="button" value="<- " (click)="removeRole()"><br>
															<input type="button" value="<<" (click)="removeall()"><br>
														</td>

														<td style="width:45%;">
															<select style="width:100%;" size="10" multiple="true"
																name="roleIds" [(ngModel)]="userselect">
																<option *ngFor="let e of getselectuserdetailselect">
																	{{e}}</option>
															</select>
														</td>
													</tr>

													<tr>
														<td colspan="3">
															<br>
															<input type="button" value="{{'Set Roles'|translate}}"
																(click)="setUserRoleDetails()">
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</form>

				</td>
			</tr>

			<!-- 4th block -->
			<tr *ngIf="showhideblock1">
				<td width="2%">&nbsp;</td>
				<td style="width:85%;font-size:12.8px;font-family:Verdana,Arial,Helvetica,Trebuchet,_sans;">{{'Qualified roles'|translate}}:</td>
			</tr>
			<tr *ngIf="showhideblock1">
				<td>&nbsp;</td>
				<td>
					<div class="whatsnewBorder" style="padding: 5px; width: 99%;">
						<table>
							<thead>
								<tr>
									<th class="summaryTitle1">{{'Role Name'|translate}}:</th>&nbsp;
									<th class="summaryTitle1">{{'Expires'|translate}}:</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let m of getselectqualifieduserdetails;">
									<td>{{m.roleName}}</td>&nbsp;
									<td>{{m.expires| date: 'dd.MM.yyyy'}}&nbsp;{{m.expires.split('T')[1].split('.')[0]}}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</td>
			</tr>

		</tbody>
	</table>
</div>

<!--popup window-->
<div class="modal-dialog modal-sm">
	<ng-template #content let-modal>
		<div class="forborder">
			<div class="modal-header">
				<div class="dialog-titlebar widget-header corner-all" id="exampleModalLongTitle" style="font-size:1em;">
					{{'User Search Results'|translate}}
				</div>
				<i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')" title="close"
					style="cursor:pointer"></i>

			</div>
			<div class="modal-body" style="height:300px; overflow: auto;">
				<div class="whatsnewBorder"
					style="padding: 5px; width: 99%; margin-bottom: 2px; height:auto; min-height: 265px;">
					<table>
						<tbody>
							<tr>
								<td>
									<div style="width: 99%; padding: 5px">
										<table class="padded-table" style="width: 100%;">
											<div *ngIf="flagset" style="width: 250px;">
												{{apierrormsg}}
											</div>
											<tbody *ngIf="!flagset">
												<tr>
													<td><span class="summaryTitle">{{'Username'|translate}}</span></td>&nbsp;&nbsp;
													<td><span class="summaryTitle">{{'User's Login Type'|translate}}</span></td>
													&nbsp;&nbsp;
													<td><span class="summaryTitle">{{'User's Full Name'|translate}}</span></td>
													&nbsp;&nbsp;
													<td><span class="summaryTitle">{{'User's Email Address'|translate}}</span></td>
													&nbsp;&nbsp;
													<td><span class="summaryTitle">{{'Market Country'|translate}}</span></td>
													&nbsp;&nbsp;
													<td><span class="summaryTitle">{{'Language'|translate}}</span></td>&nbsp;&nbsp;
													<td></td>&nbsp;&nbsp;
												</tr>
												<tr *ngFor="let i of getuserdetaildata;">
													<td><span>{{i[0]}}</span></td>&nbsp;&nbsp;
													<td><span *ngIf="1 == i[1]">{{'Ford Internal Personnel (1, fs)'|translate}}</span>
														<span *ngIf="2 == i[1]">{{'Independent Operator (2, ir)'|translate}}</span>
														<span *ngIf="3 == i[1]">{{'Authorized Repairer (3, ar)'|translate}}</span>
													</td>&nbsp;&nbsp;
													<td><span>{{i[2]}}&nbsp;{{i[3]}}</span></td>&nbsp;&nbsp;
													<td><span>{{i[4]}}</span></td>&nbsp;&nbsp;
													<td>{{i[5]}}</td>&nbsp;&nbsp;
													<td>{{i[6]}}</td>&nbsp;&nbsp;
													<td>
														<input type="radio" id="radioselect" name="radioselect"
															(click)="getUserRoleDetails(i[0],i[2],i[4],i[1],i[3],i[5],i[6]);">
													</td>&nbsp;&nbsp;
												</tr>
											</tbody>
										</table>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<input type="button" value="{{'Select'|translate}}"
					(click)="selectUserDetails();setQualifiedUserDetails();modal.close('Close click')">
				<input type="button" value="{{'Close'|translate}}" (click)="modal.close('Close click')">
			</div>
		</div>
	</ng-template>
</div>